import { render, staticRenderFns } from "./v-checkbox-group.vue?vue&type=template&id=8426285e&scoped=true&"
import script from "./v-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./v-checkbox-group.vue?vue&type=script&lang=js&"
import style0 from "./v-checkbox-group.vue?vue&type=style&index=0&id=8426285e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8426285e",
  null
  
)

export default component.exports